import { Component, EventEmitter, Input, Output, HostListener } from '@angular/core';

@Component({
  selector: 'app-nested-dropdown',
  templateUrl: './nested-dropdown.component.html',
  styleUrls: ['./nested-dropdown.component.scss']
})
export class NestedDropdownComponent {

  @Input() options: any[] = [];
  @Input() placeholder = 'Select';
  @Input() optionLabel = 'label';
  @Input() optionValue = 'value';
  @Input() disabled = false;
  @Output() selectionChange = new EventEmitter<any>();

  dropdownOpen = false;
  selectedValue: any = null;

  toggleDropdown() {
    if (this.disabled) return;
    this.dropdownOpen = !this.dropdownOpen;
  }

  selectOption(option: any, event: Event) {
    event.preventDefault();
    if (this.disabled) return;

    this.selectedValue = option[this.optionValue];
    this.selectionChange.emit(this.selectedValue);
    this.dropdownOpen = false;
  }


  getSelectedLabel(): string {
    return this.placeholder;
  }


  isSelected(option: any): boolean {
    return option[this.optionValue] === this.selectedValue;
  }

  // Close dropdown on outside click
  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    const target = event.target as HTMLElement;
    if (!target.closest('.custom-dropdown')) {
      this.dropdownOpen = false;
    }
  }
}
